import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    ButtonHLPure,
    TextAreaHLPure,
    DialogSystemGLPure,
} from "../../../pures";
import { Grid } from "@material-ui/core";

import "./digital-contract-template-delete.css";

const TemplateAdministrationDisableView = ({
    hideShowDetails,
    selectedTemplate,
    token,
    showLoadingRequest,
    showDetailComponent,
    toggleShowDetailComponent,
    showCompletedRequest,
    deleteTemplate,
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    laststateNameComponentUser,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    toggleErrorRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    message,
}) => {
    const [comments, setComments] = useState("");
    const [error, setError] = useState(false);
    const { t } = useTranslation();

    const handleChangeComments = (e) => {
        setComments(e.target.value);
    };

    const handleDelete = () => {
        if (comments.trim() === "") {
            setError(true)
            return false
        }
        setError(false)
        deleteTemplate(selectedTemplate.id, token);
    };

    const redirectToComponets = (name) => {
        setStateNameComponentUser(name);
        setHeaderTitleinDetail({ clicked: true, name: name })
    };

    return (
        <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="TemplateAdministrationDisableView-wrapper"
        >
            {showLoadingRequest ? <DialogSystemGLPure showLoadingRequesting={showLoadingRequest} /> : null}
            {showCompletedRequest ? (
                <DialogSystemGLPure showCompletedRequesting={showCompletedRequest} />
            ) : null}

            <>
                <Grid
                    container
                    direction="column"
                    className="TemplateAdministrationDisableView-body"
                >
                    <TextAreaHLPure
                        labelTextArea={t('digitalContractTemplatesDelete.Motive')}
                        valueTextData={comments}
                        handleChangeTextArea={(e) => handleChangeComments(e)}
                        errorInput={error}
                        errorTextArea={"El motivo de eliminación no puede quedar vacío, por favor establece un motivo."}
                    />
                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="TemplateAdministrationDisableView-buttonContainer"
                >
                    <Grid
                        item
                        className="TemplateAdministrationDisableView-CancelButton"
                    >
                        <ButtonHLPure
                            nameBtn={t("button.return")}
                            onClickBtn={(e) => redirectToComponets(laststateNameComponentUser)}
                        />
                    </Grid>
                    <Grid
                        item
                        className="TemplateAdministrationDisableView-SaveButton"
                    >
                        <ButtonHLPure
                            primary
                            nameBtn={t("digitalContractTemplatesDetail.buttonDelete")}
                            onClickBtn={handleDelete}
                        />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        showErrorRequesting={showErrorRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        message={message}
                    />
                </Grid>
            </>
        </Grid >
    );
};

export default TemplateAdministrationDisableView;
